<template>
  <header id="main" class="site-header">
    <div class="container header-container">
      <div class="logo-section">
        <div class="logo-item">
          <a href="/" class="logo-link">
            <img class="logo-img" src="../assets/logo.png" alt="Studio Logo" />
          </a>
        </div>
        <div class="title-item">
          <h1>האולפן ביסעור</h1>
        </div>
        <div class="image-item">
          <img class="guitar-img" src="../assets/guitar.png" alt="Guitar" />
        </div>
      </div>

      <nav class="main-nav">
        <button class="menu-toggle" @click="toggleMenu" aria-label="תפריט ניווט">
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </button>
        <div class="nav-links" :class="{ 'nav-active': menuActive }">
          <router-link to="/" @click="closeMenu">בית</router-link>
          <router-link to="/productions" @click="closeMenu">הפקות</router-link>
          <router-link to="/recommendation" @click="closeMenu">המלצות</router-link>
          <router-link to="/learn" @click="closeMenu">לימודי סאונד</router-link>
          <router-link to="/contact" @click="closeMenu">צרו קשר</router-link>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "SiteHeader",
  data() {
    return {
      menuActive: false
    };
  },
  methods: {
    toggleMenu() {
      this.menuActive = !this.menuActive;
    },
    closeMenu() {
      this.menuActive = false;
    }
  },
  created() {
    console.log("created");
  },
  watch: {
    // Close the menu when route changes
    $route() {
      this.closeMenu();
    }
  },
  mounted() {
    // Close the menu when clicking outside
    document.addEventListener('click', (event) => {
      const isClickInsideNavLinks = event.target.closest('.nav-links');
      const isClickOnMenuToggle = event.target.closest('.menu-toggle');
      
      if (this.menuActive && !isClickInsideNavLinks && !isClickOnMenuToggle) {
        this.closeMenu();
      }
    });
  },
  beforeUnmount() {
    // Clean up event listener when component is destroyed
    document.removeEventListener('click', this.closeMenu);
  }
};
</script>

<style scoped>
.site-header {
  background-color: var(--dark-bg);
  box-shadow: 0 2px 15px rgba(0,0,0,0.1);
  position: relative;
  z-index: 100;
  direction: rtl;
}

.header-container {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 1rem;
}

.logo-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0;
}

.logo-item {
  flex: 1;
  text-align: left;
}

.title-item {
  flex: 2;
  text-align: center;
}

.image-item {
  flex: 1;
  text-align: right;
}

.logo-link {
  display: inline-block;
  transition: transform 0.3s ease;
}

.logo-link:hover {
  transform: scale(1.05);
}

.logo-img {
  max-width: 180px;
  height: auto;
}

.guitar-img {
  max-width: 120px;
  height: auto;
  border-radius: 50%;
  box-shadow: 0 5px 15px rgba(255,255,255,0.3);
  transition: transform 0.3s ease;
}

.guitar-img:hover {
  transform: rotate(5deg);
}

h1 {
  font-size: 3.2rem;
  color: var(--light-text);
  margin: 0;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
  font-weight: 700;
}

.main-nav {
  background: linear-gradient(to right, var(--primary-color), var(--secondary-color));
  border-radius: 6px;
  overflow: hidden;
}

.nav-links {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.nav-links a {
  color: var(--light-text);
  text-align: center;
  padding: 1rem 1.5rem;
  text-decoration: none;
  font-size: 1.2rem;
  font-weight: 500;
  transition: all 0.3s ease;
  position: relative;
}

.nav-links a:hover {
  background-color: rgba(255,255,255,0.1);
  color: var(--accent-color);
}

.nav-links a.router-link-active {
  background-color: rgba(255,255,255,0.2);
  color: var(--accent-color);
}

.nav-links a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background: var(--accent-color);
  transition: all 0.3s ease;
  transform: translateX(-50%);
}

.nav-links a:hover::after,
.nav-links a.router-link-active::after {
  width: 60%;
}

.menu-toggle {
  display: none;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
}

.bar {
  display: block;
  width: 25px;
  height: 3px;
  margin: 5px auto;
  transition: all 0.3s ease;
  background-color: var(--light-text);
}

@media (max-width: 768px) {
  .logo-section {
    flex-direction: row;
    padding: 0.5rem 0;
  }

  .title-item {
    order: 2;
  }

  .logo-item {
    order: 1;
  }

  .image-item {
    order: 3;
  }

  h1 {
    font-size: 1.5rem;
  }

  .logo-img {
    max-width: 80px;
  }

  .guitar-img {
    max-width: 60px;
  }

  .menu-toggle {
    display: block;
    position: absolute;
    top: 1rem;
    left: 1rem;
    z-index: 1000;
  }

  .nav-links {
    position: fixed;
    top: 0;
    left: -100%;
    height: 100vh;
    width: 80%;
    max-width: 300px;
    background: var(--dark-bg);
    flex-direction: column;
    align-items: center;
    padding-top: 4rem;
    transition: left 0.3s ease;
    z-index: 999;
  }

  .nav-active {
    left: 0;
  }

  .nav-links a {
    width: 100%;
    padding: 1rem;
    border-bottom: 1px solid rgba(255,255,255,0.1);
  }
}
</style>